export default __webpack_public_path__ + "static/media/element_spec_25.879c9e00.webp";